import { List } from '@mui/material';
import React, { useMemo } from 'react';
import type { ShareAccessDisplayItem } from '../../../types';
import { useInternalShareSettings } from '../../hooks/useInternalShareSettings';
import { makeSharedWithDisplayList } from '../../utils';
import ShareActorListItem from './ShareActorListItem';

export default function ShareActorList() {
    const { shareSettings, initialShareSettings } = useInternalShareSettings();

    const sharedWithDisplayList: ShareAccessDisplayItem[] = useMemo(() => {
        return makeSharedWithDisplayList(
            shareSettings.sharedWith,
            initialShareSettings.sharedWith,
            shareSettings.sharedWithDepartments,
            initialShareSettings.sharedWithDepartments
        );
    }, [
        initialShareSettings.sharedWith,
        initialShareSettings.sharedWithDepartments,
        shareSettings.sharedWith,
        shareSettings.sharedWithDepartments
    ]);

    if (sharedWithDisplayList.length === 0) return null;

    return (
        <List disablePadding sx={{ width: '100%' }}>
            {sharedWithDisplayList.map((shareAccessDisplayItem) => (
                <ShareActorListItem
                    key={`${shareAccessDisplayItem.source}-${shareAccessDisplayItem.actor.id}`}
                    shareAccessDisplayItem={shareAccessDisplayItem}
                />
            ))}
        </List>
    );
}
